import { render, staticRenderFns } from "./ObjectImageGallery.vue?vue&type=template&id=e2e5d312&scoped=true&"
import script from "./ObjectImageGallery.vue?vue&type=script&lang=js&"
export * from "./ObjectImageGallery.vue?vue&type=script&lang=js&"
import style0 from "./ObjectImageGallery.vue?vue&type=style&index=0&id=e2e5d312&scoped=true&lang=css&"
import style1 from "./ObjectImageGallery.vue?vue&type=style&index=1&id=e2e5d312&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e5d312",
  null
  
)

export default component.exports